module.exports = __webpack_public_path__ + "img/D1F1_new.eea17191.jpg";